import store from "@/store";

export default {
    methods: {
        SaveAsDraft() {
            this.$store
                .dispatch(
                    "mediavendor/SaveRequestAsDraft",
                    this.isDraft == true ? parseInt(this.id) : null
                )
                .then((res) => {
                    console.log("SaveAsDraft response", res);
                    if (res.status == 200) {
                        store.commit("progress/removeProcessing", { root: true });
                        store.dispatch(
                            "progress/setSuccessMessage",
                            `The Media Vendor request has been saved as Draft successfully`
                        );
                        this.$router.push("/VendorRequests");
                    } else {
                        window.console.log("error while uploading files");
                    }
                })
                .catch((ex) => {
                    if (ex.response && ex.response.status == 415 && ex.response.data) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    } else {
                         this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while Saving Media Vendor as Draft. ${ex}`
                        );
                    }
                });
        },
    },
};